import {ReactElement} from 'react';

import {DataGridProps} from './DataGridProps';
import {RowData} from './RowData';

export interface MasterDetailRendererProps {
  rowData: RowData;
  gridProps: DataGridProps;
}

export type MasterDetailRenderer = (props: MasterDetailRendererProps) => ReactElement | null;
